import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageCountService {
pagenumber: any;
  constructor() { }
}
